import React from 'react';
import { ActivityLogInline } from '../ActivityLogInline';

export function ActivityLogPage({
  entityFilters
}) {
  return (
    <div className='body-container'>
      <ActivityLogInline entityFilters={entityFilters} />
    </div>
  );
}

export function ActivityLogPageWrapper(props) {
  return (
    <div>
      <ActivityLogPage {...props} />
    </div>
  );
}
